import type { ReactNode } from 'react';
import type { Permission } from '@/config/permissions';
import type { RoleCode } from '@/config/role-codes';
import { useAccessControl } from '@/contexts/AccessContext';
import type { UserRole } from '@/types/role';

type CanProps = {
  children: ReactNode;
  fallback?: ReactNode;
  permission?: Permission | string;
  anyPermission?: readonly (Permission | string)[];
  allPermissions?: readonly (Permission | string)[];
  role?: RoleCode | string;
  anyRole?: readonly (RoleCode | string)[];
  appRole?: UserRole;
  module?: string;
};

export const Can = ({
  children,
  fallback = null,
  permission,
  anyPermission,
  allPermissions,
  role,
  anyRole,
  appRole,
  module,
}: CanProps) => {
  const access = useAccessControl();

  if (permission && !access.can(permission)) return fallback;
  if (anyPermission?.length && !access.canAny(anyPermission)) return fallback;
  if (allPermissions?.length && !access.canAll(allPermissions)) return fallback;
  if (role && !access.hasRole(role)) return fallback;
  if (anyRole?.length && !access.hasAnyRole(anyRole)) return fallback;
  if (appRole && !access.hasAppRole(appRole)) return fallback;
  if (module && !access.hasModule(module)) return fallback;

  return children;
};
